
  import { full, localDayAndTime } from "@/js/local_time"

  export default {
    mounted() {
      this.form = this.el.closest("form")
      this.handler = () => this.render()
      this.form && this.form.addEventListener("input", this.handler)
      this.prefill()
      this.render()
    },
    updated() { this.render() },
    destroyed() { this.form && this.form.removeEventListener("input", this.handler) },
    field(suffix) {
      return this.form && this.form.querySelector(`[name$="[${suffix}]"]`)
    },
    value(suffix) {
      const el = this.field(suffix)
      return el ? el.value : ""
    },
    put(iso) {
      const el = this.field("recurring_at_utc")
      if (el) el.value = iso
    },
    prefill() {
      const at = this.el.dataset.defaultAt
      const day = this.field("recurring_day")
      const time = this.field("recurring_time")
      if (!at || !day || !time || day.value || time.value) return
      const slot = localDayAndTime(new Date(at))
      day.value = slot.day
      time.value = slot.time
      time.dispatchEvent(new Event("input", { bubbles: true }))
    },
    storedRun(day, time) {
      const at = this.el.dataset.defaultAt
      if (!at) return null
      const run = new Date(at)
      const slot = localDayAndTime(run)
      return slot.day === day && slot.time === time && run > new Date() ? run : null
    },
    render() {
      const day = this.value("recurring_day")
      const time = this.value("recurring_time")
      if (!day || !time) { this.el.textContent = ""; this.put(""); return }
      const stored = this.storedRun(day, time)
      if (stored) { this.show(stored, false); return }
      const now = new Date()
      const target = parseInt(day, 10)
      const [h, m] = time.split(":").map((x) => parseInt(x || "0", 10))
      const next = new Date(now)
      next.setDate(now.getDate() + ((target - now.getDay() + 7) % 7))
      next.setHours(h, m, 0, 0)
      const nextWeek = next - now < 3600000
      if (nextWeek) {
        next.setDate(next.getDate() + 7)
        next.setHours(h, m, 0, 0)
      }
      if (next.getHours() !== h || next.getMinutes() !== m) {
        this.el.textContent = `The clocks change that day, so ${time} doesn't exist then. Pick another time.`
        this.put("")
        return
      }
      this.show(next, nextWeek)
    },
    show(next, nextWeek) {
      this.put(next.toISOString())
      const at = full(next, true)
      this.el.textContent = nextWeek
        ? `Next run at: ${at}, less than an hour from now, so it is scheduled for next week.`
        : `Next run at: ${at}`
    },
  }
